var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('h4',[_vm._v("Visit Customers")])])],1),_c('div',{staticClass:"overflow-hidden"},[_c('apexchart',{attrs:{"type":"donut","height":"184px","legend":"legend","options":_vm.options,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }